import { FC } from "react";
import SuperForm from '../../../SuperForm';
import classNames from "classnames";
import { ScanPageLeftFormItemProps, ScanPageLeftItemEnum, } from "../../interface";
/** SuperForm配置左侧表单 */
const FormItem: FC<ScanPageLeftFormItemProps> = props => {
  const { testId = 'scan-page-left-form-item', formItems = [], className, style, ...restProps } = props;
  const classes = classNames('body-left-form-item', className);
  return (
    <div className={classes} style={style}>
      <SuperForm
        testId={testId}
        formItems={formItems}
        defaultLineNumber={1}
        defaultLabelCol={{span: 8}}
        {...restProps}
      />
    </div>
  );
};

FormItem.displayName = ScanPageLeftItemEnum.FormItem;

export default FormItem;